<template>
  <filter-date-time :field="field" v-if="calendar" />
  <filter-time :field="field" v-else />
</template>

<script>
import FilterDateTime from './FilterDateTime'
import FilterTime from './FilterTime'

const DATE_FORMATS = ['datetime', 'datetime_interval', 'datetime-local', 'date', 'date_interval']

export default {
  name: 'FilterDateTimeControl',
  components: {
    FilterDateTime,
    FilterTime,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  computed: {
    calendar() {
      return DATE_FORMATS.includes(this.field.type)
    },
  },
}
</script>
